import { isEqual, reduce } from 'lodash';

export const getDifferencesBetweenObjects = (a, b) => (
  reduce(a, (res, value, key) => 
    isEqual(value, b[key]) 
      ? res 
      : { ...res, [key]: b[key] }, 
    {}
  )
);
